module.exports = __webpack_public_path__ + "static/img/quick_link01.c605e4f8.png";